import React from 'react'
import Header from './components/header/Header'
import Nav from './components/nav/Nav'
import About from './components/about/About'
import Experience from './components/experience/Experience'
import Traits from './components/Traits/Traits'
import Portfolio from './components/portfolio/Portfolio'
import QA from './components/QA/QA'
import Contact from './components/contact/Contact'
import Footer from './components/footer/Footer'

const app = () => {
  return (
    <>
      <Header/>
      {/* <Home/> */}
      <Nav/>
      <About/>
      <Experience/>
      <Traits/>
      <Portfolio/>
      {/* <QA/> */}
      <Contact/>
      <Footer/>
    </>
  )
}

export default app